import { string, object, number } from 'yup';

import { YUP_ERRORS_MESSAGES } from '@shared/constants';

import { validateObjectId } from 'shared/utils';

export const vipLevelValidationSchema = object().shape({
  level: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
  title: string().trim().required(YUP_ERRORS_MESSAGES.REQUIRED),
  iconId: string()
    .test({
      message: YUP_ERRORS_MESSAGES.OBJECT_ID,
      test: validateObjectId,
    })
    .required(YUP_ERRORS_MESSAGES.IMAGE),
  levelPoints: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
});
